// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BURLc","selected":"styles_selected__JyShJ"};